"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var React = require("react");
var Autosuggest = require("react-autosuggest");
var debounce = require("javascript-debounce");
var Search = (function (_super) {
    __extends(Search, _super);
    function Search(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "onSuggestionsClearRequested", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () {
                _this.setState({
                    suggestions: []
                });
            }
        });
        _this.state = {
            value: '',
            suggestions: [],
            focusInputOnSuggestionClick: false
        };
        _this.onSuggestionsFetchRequested = debounce(_this.onSuggestionsFetchRequested.bind(_this), 300);
        _this.onSuggestionsClearRequested = _this.onSuggestionsClearRequested.bind(_this);
        _this.getSuggestionValue = _this.getSuggestionValue.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onSuggestionsSelected = _this.onSuggestionsSelected.bind(_this);
        _this.renderSuggestion = _this.renderSuggestion.bind(_this);
        _this.renderInputComponent = _this.renderInputComponent.bind(_this);
        _this.clear = _this.clear.bind(_this);
        return _this;
    }
    Object.defineProperty(Search.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a = this.state, suggestions = _a.suggestions, value = _a.value, focusInputOnSuggestionClick = _a.focusInputOnSuggestionClick;
            var inputProps = {
                placeholder: this.props.placeholder,
                value: value,
                onChange: this.onChange
            };
            return (React.createElement(Autosuggest, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, onSuggestionsClearRequested: this.onSuggestionsClearRequested, getSuggestionValue: this.getSuggestionValue, onSuggestionSelected: this.onSuggestionsSelected, renderSuggestion: this.renderSuggestion, renderInputComponent: this.renderInputComponent, focusInputOnSuggestionClick: focusInputOnSuggestionClick, highlightFirstSuggestion: true, inputProps: inputProps }));
        }
    });
    Object.defineProperty(Search.prototype, "onSuggestionsFetchRequested", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (_a) {
            var value = _a.value;
            return __awaiter(this, void 0, void 0, function () {
                var resultLimit, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            resultLimit = this.props.resultLimit;
                            if (this.state.value !== value) {
                                return [2];
                            }
                            _b = this.setState;
                            _c = {};
                            return [4, this.props.search(value, resultLimit)];
                        case 1:
                            _b.apply(this, [(_c.suggestions = _d.sent(),
                                    _c)]);
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(Search.prototype, "onChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, changeEvent) {
            this.setState({
                value: changeEvent.newValue
            });
        }
    });
    Object.defineProperty(Search.prototype, "onSuggestionsSelected", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event, data) {
            this.props.onSuggestionSelected(data.suggestion);
        }
    });
    Object.defineProperty(Search.prototype, "getSuggestionValue", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (suggestion) {
            return this.props.getSelectedValue(suggestion);
        }
    });
    Object.defineProperty(Search.prototype, "renderSuggestion", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (suggestion) {
            return (React.createElement("span", null, this.props.getRenderedSuggestionText(suggestion)));
        }
    });
    Object.defineProperty(Search.prototype, "renderInputComponent", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (inputProps) {
            var cased = inputProps;
            return (React.createElement("div", { className: "search-group" },
                React.createElement("div", { className: "input-group" },
                    React.createElement("span", { className: "icon-search" }),
                    React.createElement("input", __assign({}, cased, { className: "searchInput pxl-form-control" })),
                    React.createElement("span", { onClick: this.clear, className: "icon-cancel", hidden: this.shouldHideClearButton }))));
        }
    });
    Object.defineProperty(Search.prototype, "clear", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState({
                value: '',
                suggestions: []
            });
        }
    });
    Object.defineProperty(Search.prototype, "shouldHideClearButton", {
        get: function () {
            return this.state.value.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    return Search;
}(React.Component));
exports.Search = Search;
exports.default = mobx_react_1.observer(Search);
